// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aIxR","field":"styles_field__3mG4z","fieldCol":"styles_fieldCol__3cJod","diffCol":"styles_diffCol__bCO9j","diff":"styles_diff__1uCu6"};